import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { tillamookConfig } from "./data";

export default function TillamookPage() {
  return <OregonCityPageTemplate config={tillamookConfig} />;
}